export const pageBuilderTranslations = {
  pt: {
    header: {
      title: "Configurações da página",
      subtitle: "Personalize o visual e conteúdo da sua página de links",
      newPageTitle: "Nova página",
      newPageSubtitle: "Crie uma nova página com informações e links",
      unsavedChanges: "Você tem alterações não salvas. Tem certeza que deseja sair sem salvar?"
    },
    basicInfo: {
      title: "Informações básicas",
      subtitle: "Defina como sua página será vista pelos visitantes."
    },
    form: {
      title: {
        label: "Título da página",
        placeholder: "Digite o título da sua página..."
      },
      logo: {
        label: "Logo",
        help: "Upload de uma imagem (PNG, JPG, SVG até 500KB)",
        change: "Alterar",
        remove: "Remover",
        upload: "Clique para fazer upload do logo",
        formats: "PNG, JPG, SVG até 500KB"
      },
      description: {
        label: "Descrição",
        placeholder: "Conte um pouco sobre você ou seu negócio..."
      },
      appearance: {
        label: "Aparência",
        colorLabel: "Cor de fundo"
      },
      slug: {
        label: "Endereço da página",
        help: "Use letras minúsculas, números e hífens. Máximo de 40 caracteres.",
        placeholder: "seu-nome",
        unavailable: "Slug não disponível ou inválido",
        checking: "Verificando disponibilidade do endereço...",
        error: "Erro ao verificar slug"
      }
    },
    content: {
      title: "Conteúdo da página",
      subtitle: "Gerencie os links e redes sociais que aparecerão na sua página.",
      showLinksTitle: "Exibir título da seção de links",
      sectionTitleLabel: "Título da seção",
      sectionTitlePlaceholder: "Ex.: Meus links",
      tabs: {
        links: "Links",
        social: "Redes Sociais"
      }
    },
    preview: {
      label: "Pré-visualização em tempo real"
    },
    toast: {
      saved: "Página salva com sucesso!",
      saving: "Salvando..."
    },
    linkModal: {
      addTitle: "Adicionar link",
      editTitle: "Editar link",
      url: {
        label: "URL",
        placeholder: "https://seulink.com"
      },
      label: {
        label: "Título exibido",
        placeholder: "Ex.: Meu Instagram"
      },
      cancel: "Cancelar",
      save: "Salvar alterações",
      add: "Adicionar link",
      saving: "Salvando..."
    },
    linksList: {
      title: "Links personalizados",
      add: "Adicionar",
      edit: "Editar",
      remove: "Remover",
      untitled: "Link sem título",
      unconfigured: "Link não configurado",
      empty: {
        withPermission: "Nenhum link criado ainda. Clique em \"Adicionar\" para criar o primeiro.",
        withoutPermission: "Salve a página para liberar a criação de links personalizados."
      }
    },
    socialLinks: {
      title: "Redes sociais",
      add: "Adicionar",
      edit: "Editar",
      remove: "Remover",
      empty: "Nenhuma rede social cadastrada ainda. Clique em \"Adicionar\" para incluir seu primeiro perfil.",
      savePageFirst: "Salve a página antes de adicionar redes sociais.",
      confirmDelete: "Tem certeza que deseja remover esta rede social?",
      deleteError: "Não foi possível remover a rede social.",
      modal: {
        editTitle: "Editar rede social",
        addTitle: "Adicionar rede social",
        network: "Rede social",
        username: "Username",
        cancel: "Cancelar",
        save: "Salvar alterações",
        add: "Adicionar",
        saving: "Salvando..."
      },
      networks: {
        instagram: { label: "Instagram", placeholder: "@seuusuario" },
        facebook: { label: "Facebook", placeholder: "seu.perfil" },
        tiktok: { label: "TikTok", placeholder: "@seuusuario" },
        youtube: { label: "YouTube", placeholder: "seucanal ou @handle" },
        twitter: { label: "Twitter / X", placeholder: "@seuusuario" },
        linkedin: { label: "LinkedIn", placeholder: "seu-perfil" }
      }
    },
    deletePage: {
      deletePageButton: "Excluir página",
      modalTitle: "Excluir página",
      modalDescription: "Tem certeza que deseja excluir esta página e todos os links associados? Esta ação não pode ser desfeita.",
      cancel: "Cancelar",
      confirm: "Confirmar exclusão",
      deleting: "Excluindo..."
    }
  },
  en: {
    header: {
      title: "Page Settings",
      subtitle: "Customize your page design and content",
      newPageTitle: "New Page",
      newPageSubtitle: "Create a new page with information and links",
      unsavedChanges: "You have unsaved changes. Are you sure you want to leave without saving?"
    },
    basicInfo: {
      title: "Basic Information",
      subtitle: "Define how your page will be seen by visitors."
    },
    form: {
      title: {
        label: "Page Title",
        placeholder: "Enter your page title..."
      },
      logo: {
        label: "Logo",
        help: "Upload an image (PNG, JPG, SVG up to 500KB)",
        change: "Change",
        remove: "Remove",
        upload: "Click to upload logo",
        formats: "PNG, JPG, SVG up to 500KB"
      },
      description: {
        label: "Description",
        placeholder: "Tell a bit about yourself or your business..."
      },
      appearance: {
        label: "Appearance",
        colorLabel: "Background color"
      },
      slug: {
        label: "Page address",
        help: "Use lowercase letters, numbers and hyphens. Maximum 40 characters.",
        placeholder: "your-name",
        unavailable: "Slug not available or invalid",
        checking: "Checking address availability...",
        error: "Error checking slug"
      }
    },
    content: {
      title: "Page Content",
      subtitle: "Manage links and social networks on your page.",
      showLinksTitle: "Show links section title",
      sectionTitleLabel: "Section title",
      sectionTitlePlaceholder: "Ex.: My links",
      tabs: {
        links: "Links",
        social: "Social"
      }
    },
    preview: {
      label: "Real-time preview"
    },
    toast: {
      saved: "Page saved successfully!",
      saving: "Saving..."
    },
    linkModal: {
      addTitle: "Add link",
      editTitle: "Edit link",
      url: {
        label: "URL",
        placeholder: "https://yourlink.com"
      },
      label: {
        label: "Display title",
        placeholder: "Ex.: My Instagram"
      },
      cancel: "Cancel",
      save: "Save changes",
      add: "Add link",
      saving: "Saving..."
    },
    linksList: {
      title: "Custom links",
      add: "Add",
      edit: "Edit",
      remove: "Remove",
      untitled: "Untitled link",
      unconfigured: "Link not configured",
      empty: {
        withPermission: "No links created yet. Click \"Add\" to create the first.",
        withoutPermission: "Save the page to unlock custom link creation."
      }
    },
    socialLinks: {
      title: "Social Networks",
      add: "Add",
      edit: "Edit",
      remove: "Remove",
      empty: "No social networks added yet. Click \"Add\" to add your first profile.",
      savePageFirst: "Save the page first to add social networks.",
      confirmDelete: "Remove this social network?",
      deleteError: "Could not remove social network.",
      modal: {
        editTitle: "Edit social network",
        addTitle: "Add social network",
        network: "Social network",
        username: "Username",
        cancel: "Cancel",
        save: "Save changes",
        add: "Add",
        saving: "Saving..."
      },
      networks: {
        instagram: { label: "Instagram", placeholder: "@yourusername" },
        facebook: { label: "Facebook", placeholder: "your.profile" },
        tiktok: { label: "TikTok", placeholder: "@yourusername" },
        youtube: { label: "YouTube", placeholder: "yourchannel or @handle" },
        twitter: { label: "Twitter / X", placeholder: "@yourusername" },
        linkedin: { label: "LinkedIn", placeholder: "your-profile" }
      }
    },
    deletePage: {
      deletePageButton: "Delete page",
      modalTitle: "Delete page",
      modalDescription: "Are you sure you want to delete this page and all associated links? This action cannot be undone.",
      cancel: "Cancel",
      confirm: "Confirm deletion",
      deleting: "Deleting..."
    }
  }
};
